<div
  data-qa="org-and-fund-picker"
  id="org-and-fund-picker"
  class="picker flex flex-col"
  (mouseenter)="activateOrgFundDropDown()"
  (mouseleave)="deactivateOrgFundPicker()"
  >
  <span class="picker-header">Fund</span>
  <div
    data-qa="selected-entity-name"
    id="selected-fund-container"
    class="picker-name">
    <span>{{ selectedEntity?.name | linkShort: MAX_SELECTED_FUND_NAME_LEN }}</span>
    <app-all-icons
      [iconNameAndStyling]="'arrow-down.svg;icon-size-1p25;padding-borders-0p5;'">
    </app-all-icons>
  </div>
  <div
    *ngIf="showOrgFundPicker"
    @fadeInOut
    [formGroup]="selectedOrgForm"
    class="picker-dropdown centered-column-container">
    <div class="autocomplete-input">
      <app-input
        data-qa="org-picker-search-input"
        formControlName="selectedOrg"
        [placeholder]="'Search fund...'"
        [suffixFirstIcon]="'close.svg'"
        (suffixFirstIconEmitter)="resetOrgFundInputValue()">
      </app-input>
    </div>
    <div class="picker-list centered-column-container">
      <ng-container *ngFor="let org of selectedOrgOptions | async">
        <div [attr.data-qa]="'org-name-' + org.organization.name" class="centered-column-container list-block">
          <span class="list-subheader start-row-container flex-wrap row-gap-0p375 column-gap-0p25">
            <span >{{ org.organization.name }}</span>
          </span>
          <span *ngFor="let fund of org.organization.funds"
            class="list-entry sub-list"
            [attr.data-qa]="'fund-name-'+ fund.name"
            [class.selected]="fund === selectedEntity"
            [appScrollIntoView]="fund === selectedEntity"
            (click)="changeSelectedOption(fund, org)">
            {{ fund.name | linkShort: 65 }}
          </span>
          <ng-container *ngIf="currentService === 'FS'">
            <span *ngFor="let manEnt of org.organization.managementEntities"
              class="list-entry sub-list"
              [class.selected]="manEnt === selectedEntity"
              [appScrollIntoView]="manEnt === selectedEntity"
              (click)="changeSelectedOption(manEnt, org)">
              {{ manEnt.name }}
            </span>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>
